import React, { useState, useEffect } from "react";
import "./App.css";
import WebFont from "webfontloader";
import { BrowserRouter, Route, Routes, Navigate, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "../src/assets/elementos/cuerpo/Navbar";
import CuerpoPrincipal from "./assets/elementos/basicos/CuerpoPrincipal";
import PanelInicio from "./assets/componentes/PanelInicio";
import GestorCursosConvocatoria from "./assets/componentes/GestorCursosConvocatoria";
import GestorCurso from "./assets/componentes/GestorCurso";
import GestorCategoria from "./assets/componentes/GestorCategoria";
import GestorSubcategoria from "./assets/componentes/GestorSubcategoria";
import GestorCategoriasConvocatoria from "./assets/componentes/GestorCategoriasConvocatoria";
import GestorSubcategoriaConvocatoria from "./assets/componentes/SubcategoriasConvocatoria";
import GestionPersonasPersonas from "./assets/componentes/GestionPersonasPersonas";
import IncorporacionesPage from "./assets/componentes/incorporaciones/Incorporaciones";
import BajasPage from "./assets/componentes/incorporaciones/Bajas";
import AltaPage from "./assets/componentes/incorporaciones/AltaPage";
import BajaPage from "./assets/componentes/incorporaciones/BajaPage";
import { PATRON_ALTA, PATRON_BAJA } from "./assets/componentes/incorporaciones/rutasProceso";
import { ROLES_FICHA } from "./assets/providers/rolesFicha";
import AreasPage from "./assets/componentes/incorporaciones/Areas";
import BuzonesYListasPage from "./assets/componentes/correos/BuzonesYListas";
import { RUTA_BUZONES, CLAVE_GESTIONAR as CLAVE_CORREOS } from "./assets/componentes/correos/api";
import RecursosPage from "./assets/componentes/incorporaciones/Recursos";
import RecursoFormPage from "./assets/componentes/incorporaciones/RecursoForm";
import PuestosPage from "./assets/componentes/incorporaciones/Puestos";
import MotivosBajaPage from "./assets/componentes/incorporaciones/MotivosBaja";
import TareasBajaPage from "./assets/componentes/incorporaciones/TareasBaja";
import PerfilesPage from "./assets/componentes/incorporaciones/Perfiles";
import AvisosPage from "./assets/componentes/incorporaciones/Avisos";
import VisorListaDocumentos from "./assets/componentes/VisorListaDocumentos";
import GestorPersonas from "./assets/componentes/GestorPersonas";
import GestionPersonasEmpresas from "./assets/componentes/GestionPersonasEmpresas";
import GestorEmpresa from "./assets/componentes/GestorEmpresa";
import GestionPersonasDepartamentos from "./assets/componentes/GestionPersonasDepartamentos";
import GestorDepartamento from "./assets/componentes/GestorDepartamento";
import GestorOficina from "./assets/componentes/GestorOficina";
import GestionPersonasOficinas from "./assets/componentes/GestionPersonasOficinas";
import GestorDocumentos from "./assets/componentes/GestorDocumentos";
import GestorSalasReservas from "./assets/componentes/GestorSalasReservas";
import FormLogin from "./assets/elementos/complejos/FormLogin";
import { UsuarioProvider } from './assets/providers/personaContext';
import ProtectedRoute from "./assets/providers/ProtectedRoute";
import AuthManager from './assets/providers/AuthManager';
import Organigrama from "./assets/componentes/Organigrama";
import FormEditarPerfil from "./assets/elementos/complejos/FormEditarPerfil";
import FormRecuperarPassword from "./assets/elementos/complejos/FormRecuperarPassword";
import FormNuevaPassRecuperacion from "./assets/elementos/complejos/FormNuevaPassRecuperacion";
import FormularioPublicoIncorporacion from "./assets/componentes/incorporaciones/FormularioPublico";
import GestorBlogPublicaciones from "./assets/componentes/GestorBlogPublicaciones";
import GestorPublicacion from "./assets/componentes/GestorPublicacion";
import GestorVacacionesDashboard from "./assets/componentes/GestorVacacionesDashboard";
import GestorMisSolicitudes from "./assets/componentes/GestorMisSolicitudes";
import GestorAprobaciones from "./assets/componentes/GestorAprobaciones";
import GestorCalendarioVacaciones from "./assets/componentes/GestorCalendarioVacaciones";
import GestorFestivos from "./assets/componentes/GestorFestivos";
import GestorPeriodosVerano from "./assets/componentes/GestorPeriodosVerano";
import GestorAsignacionVacaciones from "./assets/componentes/GestorAsignacionVacaciones";
import GestorRingOver from "./assets/componentes/GestorRingOver";
import GestorRingOverConfig from "./assets/componentes/GestorRingOverConfig";
import GestorPermisos from "./assets/componentes/GestorPermisos";
import ShowcaseV2 from "./assets/componentes/ShowcaseV2";
import ShowcaseV25 from "./assets/componentes/ShowcaseV25";
import PruebaV2 from "./PruebaV2";

// Fase 9: módulo legacy de intervenciones eliminado (componentes borrados).
// Las rutas /gestionintervenciones/* ahora redirigen al módulo nuevo (ver abajo).

import GestorCategoriaPublicaciones from "./assets/componentes/GestorCategoriaPublicacion";
import GestorCategoriasPublicacionesDatos from "./assets/componentes/GestorCategoriasPublicacionesDatos";

import { inventarioRoutes } from "./assets/componentes/inventario/routes";
import { formacionRoutes } from "./assets/componentes/laeformacion/routes";
// Módulo Intervenciones (citas técnicas) — Fase 2, pantalla 1/7: Lista de campañas (nuevo)
import ListaCampanasV2 from "./assets/componentes/intervenciones/pages/ListaCampanas";
// Fase 2b: wizard de crear/continuar borrador de campaña (módulo nuevo)
import CrearCampanaV2 from "./assets/componentes/intervenciones/pages/CrearCampana";
// Fase 2c: editor de campaña Activa/Pausada
import EditarCampanaV2 from "./assets/componentes/intervenciones/pages/EditarCampana";
import ResumenCampanaV2 from "./assets/componentes/intervenciones/pages/ResumenCampana";
import DashboardV2 from "./assets/componentes/intervenciones/pages/Dashboard";
import CalendarioV2 from "./assets/componentes/intervenciones/pages/Calendario";
import InformesV2 from "./assets/componentes/intervenciones/pages/Informes";
import PlantillasNotificacionesV2 from "./assets/componentes/configuracion/PlantillasNotificaciones";
import PreferenciasNotifV2 from "./assets/componentes/intervenciones/pages/PreferenciasNotificaciones";
// Fase 3a: vista usuario final (mis citas + reservar)
import MisCampanasV2 from "./assets/componentes/intervenciones/pages/MisCampanas";
import SoporteAreas from "./assets/componentes/soporte/SoporteAreas";
import SoporteDashboard from "./assets/componentes/soporte/SoporteDashboard";
import SoporteNuevo from "./assets/componentes/soporte/SoporteNuevo";
import SoporteTicketDetalle from "./assets/componentes/soporte/SoporteTicketDetalle";
import SoportePanel from "./assets/componentes/soporte/SoportePanel";
import SoportePanelDetalle from "./assets/componentes/soporte/SoportePanelDetalle";
import SoporteEquipo from "./assets/componentes/soporte/SoporteEquipo";
import ReservarCitaV2 from "./assets/componentes/intervenciones/pages/ReservarCita";
import PanelTecnicoV2 from "./assets/componentes/intervenciones/pages/PanelTecnico";

WebFont.load({
  google: {
    families: ["Montserrat", "Dosis", "Roboto", "sans-serif", "Open Sans"],
  },
});

// Fase 9 · Redirects legacy con parámetro de path -> ruta equivalente del módulo nuevo.
function RedirigirResumenCampanaLegacy() {
  const { id } = useParams();
  return <Navigate to={`/citas-tecnicas/campanas/${id}/resumen`} replace />;
}
function RedirigirEditarCampanaLegacy() {
  const { id } = useParams();
  return <Navigate to={`/citas-tecnicas/campanas/${id}/editar`} replace />;
}

const App = () => {
  const [sidebar, setSidebar] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [autenticado, setAutenticado] = useState(localStorage.getItem("token") ? true : false);
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      setAutenticado(!!token);
    };
    
    checkAuth();
  }, []);

  return (
    <>
      <UsuarioProvider>
        <Helmet>
          <title>GRUPO LAE - Intranet</title>
        </Helmet>
        <BrowserRouter>
          <AppContent 
            autenticado={autenticado}
            setAutenticado={setAutenticado}
            sidebar={sidebar}
            setSidebar={setSidebar}
            isOpen={isOpen}
            setOpen={setOpen}
            isMobile={isMobile}
          />
        </BrowserRouter>
      </UsuarioProvider>
      {/* ToastContainer global único de la app (resto de pantallas montan el suyo local) */}
      <ToastContainer position="top-right" autoClose={3500} hideProgressBar newestOnTop theme="light" />
    </>
  );
};

const AppContent = ({ 
  autenticado, 
  setAutenticado, 
  sidebar, 
  setSidebar, 
  isOpen, 
  setOpen, 
  isMobile 
}) => {
  const location = useLocation();

  const redirectToLogin = () => (
    <Navigate to="/login" state={{ from: location }} replace />
  );

  /* Fase 13 · aquí vivía la redirección forzosa al perfil cuando `requires2FASetup`.
   *
   * Se ha ido con el cerrojo entero: el segundo factor sale del login y sólo se pide en las
   * puertas. Tres consumidores vivos y un productor comentado era lo peligroso — si alguien
   * descomentaba aquella línea creyendo que activaba algo opcional, activaba **un cerrojo que
   * encierra a la gente en el perfil**. */
  const authOrRedirect = (component) => {
    if (!autenticado) return redirectToLogin();
    return component;
  };

  return (
    <>
      {autenticado && <AuthManager setAutenticado={setAutenticado} />}

      {autenticado ? (
        <Navbar sidebar={sidebar} setSidebar={setSidebar} isOpen={isOpen} setOpen={setOpen} setAutenticado={setAutenticado} />
      ) : null}
      <CuerpoPrincipal showSidebar={sidebar} autenticado={autenticado} setAutenticado={setAutenticado} isOpen={isOpen} isMobile={isMobile}>
        <Routes>
          <Route path="/login" element={autenticado ? <Navigate to="/panel-inicio" replace /> : <FormLogin setAutenticado={setAutenticado} />} />
          <Route path="/cambiarPassword" element={<FormRecuperarPassword />} />
          <Route path="/cambiarPassword/:token" element={<FormNuevaPassRecuperacion setAutenticado={setAutenticado} />} />
          {/* Formulario público del candidato (Fase 8): sin gate de sesión, credencial = token de la URL. */}
          {/* El formulario PÚBLICO del candidato es del módulo y se va con él: si el módulo está
              oculto, nadie debería poder enviarlo. Su gate NO puede ser `ProtectedRoute` —esta
              ruta es anónima, no hay sesión ni contexto de permisos—, así que lo decide el
              backend: con el módulo apagado, `/api/incorporaciones-publico` no está montado y la
              página no puede cargar ni enviar nada. La pantalla se deja, y el 404 lo pone el
              servidor, que es quien de verdad lo sabe. */}
          <Route path="/incorporaciones/formulario/:token" element={<FormularioPublicoIncorporacion />} />

          <Route
            path="/"
            element={
              autenticado ? (
                <Navigate to={window.location.pathname !== "/" ? window.location.pathname : "/panel-inicio"} replace />
              ) : (
                <Navigate to="/login" state={{ from: location }} />
              )
            }
          />

          {/* Abrir, crear y editar fichas: los mismos tres roles que el servidor (ver rolesFicha.js). */}
          <Route element={<ProtectedRoute allowedRoles={ROLES_FICHA} />}>
            <Route path='/gestionpersonas/personas/crearPersona' element={authOrRedirect(<GestorPersonas crear={true} tipo="empleado" />)} />
            <Route path='/gestionpersonas/personas/editarPersona/:Id' element={authOrRedirect(<GestorPersonas crear={false} tipo="empleado" />)} />
            <Route path='/gestionpersonas/personas-colaboradoras/crearColaborador' element={authOrRedirect(<GestorPersonas crear={true} tipo="colaboradora" />)} />
            <Route path='/gestionpersonas/personas-colaboradoras/editarColaborador/:Id' element={authOrRedirect(<GestorPersonas crear={false} tipo="colaboradora" />)} />
          </Route>


          <Route element={<ProtectedRoute allowedRoles={["administrador", "super administrador"]} />}>
          
            <Route path='/gestionpersonas/empresas' element={authOrRedirect(<GestionPersonasEmpresas isMobile={isMobile} />)} />
            
            {/*EEmpresas anterior
            <Route path='/gestionpersonas/empresas/crearEmpresa' element={authOrRedirect(<GestorEmpresa crear={true} />)} />
            <Route path='/gestionpersonas/empresas/editarEmpresa/:Id' element={authOrRedirect(<GestorEmpresa crear={false} />)} />
            {/*Eliminar al terminar el renombramiento*/}
            
            {/*Apartado de renombre de Empresas a Negocios*/}
            <Route path='/gestionpersonas/negocios/crearNegocio' element={authOrRedirect(<GestorEmpresa crear={true} />)} />
            <Route path='/gestionpersonas/negocios/editarNegocio/:Id' element={authOrRedirect(<GestorEmpresa crear={false} />)} />
            {/*Apartado de renombre de Empresas a Negocios*/}

            <Route path='/gestionpersonas/empresas-colaboradoras/crear' element={authOrRedirect(<GestorEmpresa crear={true} tipo="colaboradora" />)} />
            <Route path='/gestionpersonas/empresas-colaboradoras/editar/:Id' element={authOrRedirect(<GestorEmpresa crear={false} tipo="colaboradora" />)} />

            {/*renombre de Negocios a Empresas*/}
            <Route path="/gestionpersonas/empresas/crearEmpresa" element={authOrRedirect(<GestorEmpresa crear={true} tipo="empresa" />)} />
            <Route path="/gestionpersonas/empresas/editarEmpresa/:Id" element={authOrRedirect(<GestorEmpresa crear={false} tipo="empresa" />)} />
            {/*renombre de Negocios a Empresas*/}

            <Route path='/gestionpersonas/departamentos' element={authOrRedirect(<GestionPersonasDepartamentos isMobile={isMobile} />)} />
            <Route path='/gestionpersonas/departamentos/crearDepartamento' element={authOrRedirect(<GestorDepartamento crear={true} />)} />
            <Route path='/gestionpersonas/departamentos/editarDepartamento/:Id' element={authOrRedirect(<GestorDepartamento crear={false} />)} />

            <Route path='/gestionpersonas/oficinas/crearOficina' element={authOrRedirect(<GestorOficina crear={true} />)} />
            <Route path='/gestionpersonas/oficinas/editarOficina/:Id' element={authOrRedirect(<GestorOficina crear={false} />)} />

            {/* Fase 9: rutas legacy de intervenciones eliminadas. Redirects abajo (bloque dedicado). */}
          </Route>

          {/* Estadísticas: gobernada SOLO por la clave `ringover` (+ bypass Super Admin
              en ProtectedRoute). Se retiró allowedRoles={["administrador"]}, que dejaba
              entrar a cualquier admin por URL sin la clave; ahora ruta e icono del rail
              dicen lo mismo. La clave sigue siendo delegable a cualquier rol/persona. */}
          <Route element={<ProtectedRoute requiredPermission="ringover" />}>
            <Route path='/estadisticas/ringover' element={authOrRedirect(<GestorRingOver />)} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["super administrador"]} />}>
            <Route path='/configuracion/permisos' element={authOrRedirect(<GestorPermisos />)} />
            <Route path='/estadisticas/ringover/configuracion' element={authOrRedirect(<GestorRingOverConfig />)} />
            <Route path='/ui-v2' element={authOrRedirect(<ShowcaseV2 />)} />
            <Route path='/ui-v2-5' element={authOrRedirect(<ShowcaseV25 />)} />
            <Route path='/prueba-v2' element={authOrRedirect(<PruebaV2 />)} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["administrador", "gestor de contenidos", "super administrador"]} />}>
            <Route path="/convocatoria/cursos" element={authOrRedirect(<GestorCursosConvocatoria isMobile={isMobile} />)} />
            <Route path="/convocatoria/cursos/crearCurso" element={authOrRedirect(<GestorCurso crear={true} />)} />
            <Route path="/convocatoria/cursos/editarCurso/:Id" element={authOrRedirect(<GestorCurso crear={false} />)} />

            <Route path="/convocatoria/categorias" element={authOrRedirect(<GestorCategoriasConvocatoria isMobile={isMobile} />)} />
            <Route path="convocatoria/categorias/crearCategoria" element={authOrRedirect(<GestorCategoria crear={true} />)} />
            <Route path="/convocatoria/categorias/editarCategoria/:Id" element={authOrRedirect(<GestorCategoria crear={false} />)} />

            <Route path="/convocatoria/subcategorias/" element={authOrRedirect(<GestorSubcategoriaConvocatoria isMobile={isMobile} />)} />
            <Route path="/convocatoria/subcategorias/crearSubcategoria" element={authOrRedirect(<GestorSubcategoria crear={true} />)} />
            <Route path="/convocatoria/subcategorias/editarSubcategoria/:Id" element={authOrRedirect(<GestorSubcategoria crear={false} />)} />

          </Route>
          <Route path="/gestionpersonas/personas" element={authOrRedirect(<GestionPersonasPersonas isMobile={isMobile} />)} />

          {/* El WIZARD de altas — permiso fino Y interruptor de módulo. `requiredModule` se
              comprueba ANTES del bypass de Super Administrador: escribir la URL con el módulo
              apagado no entra, tampoco con ese rol. */}
          <Route element={<ProtectedRoute requiredModule="incorporaciones" requiredPermission="incorporaciones.ver" />}>
            <Route path="/gestionpersonas/personas/incorporaciones" element={<IncorporacionesPage />} />
            {/* El alta con pantalla propia: MISMO grupo, mismo módulo y mismo permiso que el embudo.
                Si se apaga el módulo, la URL de un alta tampoco entra. */}
            <Route path={PATRON_ALTA} element={<AltaPage />} />
          </Route>
          {/* BAJAS se queda SIEMPRE, sin interruptor: el proceso se abre desde la ficha y aquí es
              donde se consulta. Apagarlo sería no poder dar de baja a nadie. */}
          <Route element={<ProtectedRoute requiredPermission="bajas.ver" />}>
            <Route path="/gestionpersonas/personas/bajas" element={<BajasPage />} />
            <Route path={PATRON_BAJA} element={<BajaPage />} />
          </Route>
          {/* BUZONES Y LISTAS (30/10): las cuentas compartidas, en Personas y SIN el interruptor de
              Incorporaciones. Antes vivían en su configuración. */}
          <Route element={<ProtectedRoute requiredPermission={CLAVE_CORREOS} />}>
            <Route path={RUTA_BUZONES} element={<BuzonesYListasPage />} />
          </Route>
          {/* La ruta vieja REDIRIGE, y FUERA de cualquier guarda: con el módulo apagado, una guarda
              de Incorporaciones la cortaría antes de redirigir. Quien llega sin permiso lo
              decide la guarda de la ruta nueva. */}
          <Route path="/gestionpersonas/personas/incorporaciones/cuentas" element={<Navigate to={RUTA_BUZONES} replace />} />
          {/* Configuración del módulo (Fase 4) — permiso fino Y interruptor. */}
          <Route element={<ProtectedRoute requiredModule="incorporaciones" requiredPermission="incorporaciones.configurar" />}>
            <Route path="/gestionpersonas/personas/incorporaciones/areas" element={<AreasPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/recursos" element={<RecursosPage />} />
            {/* Rutas hijas del catálogo: el formulario de recurso es una PÁGINA, no un modal.
                Con URL propia se puede compartir y el navegador recuerda dónde estabas. */}
            <Route path="/gestionpersonas/personas/incorporaciones/recursos/nuevo" element={<RecursoFormPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/recursos/:id" element={<RecursoFormPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/puestos" element={<PuestosPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/motivos-baja" element={<MotivosBajaPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/tareas-baja" element={<TareasBajaPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/perfiles" element={<PerfilesPage />} />
            <Route path="/gestionpersonas/personas/incorporaciones/avisos" element={<AvisosPage />} />
          </Route>
          {/* SIN ENTRADA DE MENU, Y A PROPOSITO. Esta ruta NO es un resto: su entrada en
              `SubSiderbar` esta comentada desde julio de 2025 por decision de direccion, pero la
              pantalla SE USA — hay quien entra por esta URL directa, y de cara a 2027 puede volver
              a hacerse visible. No se retira sin preguntar: sus usuarios no aparecen en ningun
              menu, asi que su uso no se puede medir mirando la navegacion. */}
          <Route path="/gestionpersonas/organigrama" element={authOrRedirect(<Organigrama isMobile={isMobile} />)} />
          <Route path='/gestionpersonas/oficinas' element={authOrRedirect(<GestionPersonasOficinas isMobile={isMobile} />)} />

          <Route path="/documentos/wiki" element={authOrRedirect(<VisorListaDocumentos isMobile={isMobile} />)} />
          <Route path="/documentos/gestionar" element={authOrRedirect(<GestorDocumentos isMobile={isMobile} />)} />

          <Route path='/utilidades' element={authOrRedirect(<GestorSalasReservas isMobile={isMobile} />)} />
          {/* Redirect legacy: /inventario/reservas → /utilidades (preserva querystring; replace para no ensuciar el back). */}
          <Route path='/inventario/reservas' element={<Navigate to={`/utilidades${window.location.search}`} replace />} />

          {/* === Fase 9 · Redirects legacy -> nuevo módulo (período de gracia 1-2 meses) ===
              <Navigate replace> no contamina el historial. Sin gate de rol: el destino
              nuevo ya aplica su propia protección. Catch-all al final cubre URLs no listadas. */}
          <Route path="/gestionintervenciones/dashboard" element={<Navigate to="/citas-tecnicas/dashboard" replace />} />
          <Route path="/gestionintervenciones/listacampanas" element={<Navigate to="/citas-tecnicas/campanas" replace />} />
          <Route path="/gestionintervenciones/crearcampana" element={<Navigate to="/citas-tecnicas/campanas/nueva" replace />} />
          <Route path="/gestionintervenciones/editarcampana/:id" element={<RedirigirEditarCampanaLegacy />} />
          <Route path="/gestionintervenciones/informesactividad" element={<Navigate to="/citas-tecnicas/informes" replace />} />
          <Route path="/gestionintervenciones/calendariocampanas" element={<Navigate to="/citas-tecnicas/calendario" replace />} />
          <Route path="/gestionintervenciones/miscitas" element={<Navigate to="/citas-tecnicas/mis-campanas" replace />} />
          <Route path="/gestionintervenciones/resumencampana/:id" element={<RedirigirResumenCampanaLegacy />} />
          {/* /ayuda: obsoleta (sin equivalente nuevo) -> dashboard */}
          <Route path="/gestionintervenciones/ayuda" element={<Navigate to="/citas-tecnicas/dashboard" replace />} />
          {/* Catch-all: cualquier /gestionintervenciones/* no listado -> lista de campañas */}
          <Route path="/gestionintervenciones/*" element={<Navigate to="/citas-tecnicas/campanas" replace />} />

          <Route path='/panel/vacaciones/dashboard' element={<Navigate to="/panel-inicio" replace />} />
          <Route path='/panel/vacaciones/mis-solicitudes' element={authOrRedirect(<GestorMisSolicitudes />)} />
          <Route path='/panel/vacaciones/solicitar' element={authOrRedirect(<GestorMisSolicitudes />)} />
          <Route path='/panel/vacaciones/calendario' element={authOrRedirect(<GestorCalendarioVacaciones />)} />
          <Route path='/panel/vacaciones/festivos' element={authOrRedirect(<GestorFestivos />)} />

          <Route element={<ProtectedRoute allowedRoles={["super administrador", "recursos humanos"]} allowSupervisors={true} allowGestionVacaciones={true} />}>
            <Route path='/panel/vacaciones/aprobaciones' element={authOrRedirect(<GestorAprobaciones />)} />
          </Route>

          {/* Asignación masiva de calendario laboral (extraída de las pestañas de Personas, Fase 1).
              Gate SOLO super administrador / recursos humanos (mismo rolAdmin que tenían las pestañas). */}
          <Route element={<ProtectedRoute allowedRoles={["super administrador", "recursos humanos"]} />}>
            <Route path='/panel/vacaciones/asignacion' element={authOrRedirect(<GestorAsignacionVacaciones />)} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["administrador", "general", "super administrador", "recursos humanos"]} />}>
            <Route path='/panel/vacaciones/periodos-verano' element={authOrRedirect(<GestorPeriodosVerano />)} />
          </Route>

          <Route path='/panel/vacaciones/calendarios-laborales' element={<Navigate to="/panel/vacaciones/calendario" replace />} />

          <Route path='/panel-inicio' element={authOrRedirect(<GestorVacacionesDashboard />)} />
          <Route path='/perfil' element={autenticado ? <FormEditarPerfil /> : redirectToLogin()} />


          <Route element={<ProtectedRoute allowedRoles={["administrador", "gestor de contenidos", "super administrador"]} />}>
            <Route path="/comunicacion/blogs/" element={authOrRedirect(<GestorBlogPublicaciones isMobile={isMobile} />)} />
            <Route path="/comunicacion/blogs/crearPublicacion" element={authOrRedirect(<GestorPublicacion crear={true} />)} />
            <Route path="/comunicacion/blogs/editarPublicacion/:Id" element={authOrRedirect(<GestorPublicacion crear={false} />)} />

            <Route path="/comunicacion/categorias" element={authOrRedirect(<GestorCategoriasPublicacionesDatos isMobile={isMobile} />)} />
            <Route path="/comunicacion/categorias/crearCategoria" element={authOrRedirect(<GestorCategoriaPublicaciones crear={true} />)} />
            <Route path="/comunicacion/categorias/editarCategoria/:Id" element={authOrRedirect(<GestorCategoriaPublicaciones crear={false} />)} />

          </Route>

          <Route path='/perfil' element={authOrRedirect(<FormEditarPerfil />)} />

          {/* II.6 Capa 1 · módulo Inventario accesible a quien tenga
              CUALQUIER permiso fino del módulo (inventario.*). El Super
              Administrador pasa siempre (bypass en ProtectedRoute). El
              control fino por sección lo hace el backend (cada endpoint
              valida su permiso) y el subsidebar. Sustituye al CANDADO v1
              que lo limitaba a 'super administrador'. */}
          <Route element={<ProtectedRoute requiredPermissionPrefix="inventario." />}>
            {inventarioRoutes}
          </Route>

          {/* Módulo Formación (LAE). Mismo patrón que Inventario:
              accesible a quien tenga CUALQUIER permiso fino formacion.*
              (Super Admin pasa por bypass en ProtectedRoute). */}
          <Route element={<ProtectedRoute requiredPermissionPrefix="formacion." />}>
            {formacionRoutes}
          </Route>

          {/* Módulo Intervenciones (citas técnicas) — Fase 2, pantalla 1/7.
              Convive con el legacy /gestionintervenciones/*. Gated por el
              permiso fino intervenciones.campanas.view (Super Admin bypass). */}
          {/* Dashboard del módulo (vista global admin). Permiso propio dashboard.view. */}
          <Route element={<ProtectedRoute requiredPermission="intervenciones.dashboard.view" />}>
            <Route path="/citas-tecnicas/dashboard" element={<DashboardV2 />} />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="intervenciones.campanas.view" />}>
            <Route path="/citas-tecnicas/campanas" element={<ListaCampanasV2 />} />
            <Route path="/citas-tecnicas/campanas/:id/resumen" element={<ResumenCampanaV2 />} />
            <Route path="/citas-tecnicas/calendario" element={<CalendarioV2 />} />
          </Route>
          {/* Informes — permiso propio informes.view. */}
          <Route element={<ProtectedRoute requiredPermission="intervenciones.informes.view" />}>
            <Route path="/citas-tecnicas/informes" element={<InformesV2 />} />
          </Route>
          {/* Wizard de crear/continuar borrador — requiere permiso manage (más restrictivo). */}
          <Route element={<ProtectedRoute requiredPermission="intervenciones.campanas.manage" />}>
            <Route path="/citas-tecnicas/campanas/nueva" element={<CrearCampanaV2 />} />
            <Route path="/citas-tecnicas/campanas/:id/wizard" element={<CrearCampanaV2 />} />
            <Route path="/citas-tecnicas/campanas/:id/editar" element={<EditarCampanaV2 />} />
            {/* Fase 23 — ruta canónica en /configuracion; redirect temporal (~2 meses, hasta ~sept 2026) desde la vieja. */}
            <Route path="/configuracion/plantillas-notificaciones" element={<PlantillasNotificacionesV2 />} />
            <Route path="/citas-tecnicas/plantillas-notificaciones" element={<Navigate to="/configuracion/plantillas-notificaciones" replace />} />
          </Route>
          {/* Módulo Soporte · Fase 1 — solo la config de áreas (sin sidebar todavía). */}
          <Route element={<ProtectedRoute requiredPermission="soporte.panel.manage" />}>
            <Route path="/soporte/configuracion/areas" element={<SoporteAreas />} />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="soporte.panel.view" />}>
            <Route path="/soporte/panel" element={<SoportePanel />} />
            <Route path="/soporte/panel/ticket/:id" element={<SoportePanelDetalle />} />
            <Route path="/soporte/equipo" element={<SoporteEquipo />} />
          </Route>
          {/* Soporte · Fase 2A — lado usuario (solo autenticación, sin permiso). */}
          <Route path="/soporte/mis-tickets" element={authOrRedirect(<SoporteDashboard />)} />
          <Route path="/soporte/nuevo" element={authOrRedirect(<SoporteNuevo />)} />
          <Route path="/soporte/ticket/:id" element={authOrRedirect(<SoporteTicketDetalle />)} />
          {/* Alias público estable de los emails de Citas Técnicas ({{url_mis_citas}}
              = FRONTEND_URL + /mis-citas). Se mantiene fijo hacia fuera (los correos
              ya enviados apuntan aquí para siempre) y redirige a la ruta interna, que
              puede cambiar. Sin guard propio: el destino ya está protegido, y así el
              location.state.from que se guarda al ir a login es el destino REAL
              (/citas-tecnicas/mis-campanas), no /mis-citas. `replace` para no dejar el
              alias en el historial. */}
          <Route path="/mis-citas" element={<Navigate to="/citas-tecnicas/mis-campanas" replace />} />

          {/* Vista usuario final — eje participación O permiso, igual que
              `accesoMisCitas` en backend: pasa quien participe como usuario en
              alguna campaña (es_usuario_activo) O tenga la clave miscitas.view. */}
          <Route element={<ProtectedRoute requiredPermission="intervenciones.miscitas.view" allowIfParticipante />}>
            <Route path="/citas-tecnicas/mis-campanas" element={<MisCampanasV2 />} />
            <Route path="/citas-tecnicas/mis-campanas/:id/reservar" element={<ReservarCitaV2 />} />
          </Route>
          {/* Panel del técnico — eje TÉCNICO: ser participante-usuario no basta,
              hay que ser técnico activo (es_tecnico_activo). Super Admin bypassa. */}
          <Route element={<ProtectedRoute allowIfTecnico />}>
            <Route path="/citas-tecnicas/panel-tecnico" element={<PanelTecnicoV2 />} />
          </Route>
          {/* Preferencias de notificaciones — solo auth (cualquier usuario gestiona las suyas). */}
          <Route path="/citas-tecnicas/preferencias-notificaciones" element={authOrRedirect(<PreferenciasNotifV2 />)} />
        </Routes>
      </CuerpoPrincipal>
    </>
  );
};

export default App;